import React from "react";
import "./OurOffices.css";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";

const OurOffices = () => {
  return (
    <section className="oglitz-offices">
      <div className="oglitz-offices-header">
        <span className="oglitz-offices-badge">Our Locations</span>
        <h2>Our Offices</h2>
        <p>
          Strategically located offices enabling global delivery, local
          expertise, and seamless collaboration across regions.
        </p>
      </div>

      <div className="oglitz-offices-grid">
        {/* INDIA OFFICE */}
        <div className="oglitz-office-card">
          <div className="oglitz-office-watermark">I</div>

          <span className="oglitz-office-tag">Head Office</span>

          <h3>India</h3>
          <p className="oglitz-office-desc">
            Our primary engineering and delivery hub, driving innovation,
            development, and core technology execution.
          </p>

          <ul className="oglitz-office-meta">
            <li>
              <LocationOnIcon /> Engineering & Delivery Hub
            </li>
            <li>
              <BusinessCenterIcon /> Product Development & Architecture
            </li>
            <li>
              <AccessTimeIcon /> IST Time Zone
            </li>
          </ul>
        </div>

        {/* DUBAI OFFICE */}
        <div className="oglitz-office-card premium">
          <div className="oglitz-office-watermark">D</div>

          <span className="oglitz-office-tag accent">Regional Office</span>

          <h3>Dubai, UAE</h3>
          <p className="oglitz-office-desc">
            Our Middle East operations center, focused on client engagement,
            regional partnerships, and project coordination.
          </p>

          <ul className="oglitz-office-meta">
            <li>
              <LocationOnIcon /> Middle East Operations
            </li>
            <li>
              <BusinessCenterIcon /> Client Relations & Coordination
            </li>
            <li>
              <AccessTimeIcon /> GST Time Zone
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default OurOffices;
